import { fuego } from '@store/firebase';
import { CollectionPath } from '@typings/collections.enum';

export async function getUidByCharID({ collectionPath, photocardID }) {
  const _collectionPath = collectionPath || CollectionPath.PHOTOCARD;
  const ref = fuego.db.collection(_collectionPath).doc(photocardID);

  const ownerID = await ref.get().then((res) => {
    const result = res.data();
    return result?.owner;
  });

  return ownerID;
}
